export default __webpack_public_path__ + "static/media/fw-hailey-er-Rose Gold.509573e4.mp4";